import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-container" }

import Intro from '@/components/product/masterProduct/create/CreateProduct.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'PageProduct',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Intro)
  ]))
}
}

})